declare global {
    interface RouterMeta {
        title: string;
    }
    interface Router {
        path: string;
        name: string;
        icon?: string;
        permission?: string;
        meta?: RouterMeta;
        component: any;
        children?: Array<Router>;
    }
    interface System {
        import(request: string): Promise<any>
    }
    var System: System
}
import login from '../views/login.vue'
import home from '../views/home/home.vue'
import main from '../views/main.vue'

export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => import('../components/lockscreen/components/locking-page.vue')
};
export const loginRouter: Router = {
    path: '/',
    name: 'login',
    meta: {
        title: 'LogIn'
    },
    component: () => import('../views/login.vue')
};

// export const screenRouter: Router = {
//     path: '/three/screen',
//     name: 'screen',
//     meta: {
//         title: 'screen'
//     },
//     component: () => import('../views/three/screen/screen.vue')
// };
export const screenRouter: Router = {
    path: '/three/newscreen',
    name: 'screen',
    meta: {
        title: 'screen'
    },
    component: () => import('../views/three/screen/newscreen.vue')
};

export const threefuliaoRouter: Array<Router> = [{
    path: '/three/fuliao',
    name: 'three',
    component: () => import('../views/three/fuliao/building.vue')
},
{
    path: '/fuliao/onefloor',
    name: 'onefloor',
    component: () => import('../views/three/fuliao/onefloor.vue')
},
{
    path: '/fuliao/twofloor',
    name: 'twofloor',
    component: () => import('../views/three/fuliao/twofloor.vue')
},
{
    path: '/fuliao/threefloor',
    name: 'threefloor',
    component: () => import('../views/three/fuliao/threefloor.vue')
},
{
    path: '/fuliao/fourfloor',
    name: 'fourfloor',
    component: () => import('../views/three/fuliao/fourfloor.vue')
},
{
    path: '/fuliao/fivefloor',
    name: 'fivefloor',
    component: () => import('../views/three/fuliao/fivefloor.vue')
},
];

export const threeyanyeRouter: Array<Router> = [{
    path: '/three/yanye',
    name: 'three',
    component: () => import('../views/three/yanye/building.vue')
},
{
    path: '/yanye/one-floor',
    name: 'one-floor',
    component: () => import('../views/three/yanye/one-floor.vue')
},
{
    path: '/yanye/two-floor',
    name: 'two-floor',
    component: () => import('../views/three/yanye/two-floor.vue')
},
{
    path: '/yanye/three-floor',
    name: 'three-floor',
    component: () => import('../views/three/yanye/three-floor.vue')
},
{
    path: '/yanye/four-floor',
    name: 'four-floor',
    component: () => import('../views/three/yanye/four-floor.vue')
},
{
    path: '/yanye/five-floor',
    name: 'five-floor',
    component: () => import('../views/three/yanye/five-floor.vue')
},
];


export const otherRouters: Router = {
    path: '/main',
    name: 'main',
    permission: '',
    meta: { title: 'ManageMenu' },
    component: main,
    children: [
        { path: 'home', meta: { title: 'HomePage' }, name: 'home', component: () => import('../views/home/home.vue') }
    ]
}
export const appRouters: Array<Router> = [
    {
        path: '/monitor',
        name: 'monitor',
        permission: '',
        meta: { title: '数据监控' },
        icon: 'md-videocam',
        component: main,
        children: [
            { path: 'globalmonitor', permission: 'Pages.Globalmonitor', meta: { title: 'Globalmonitor' }, name: 'globalmonitor', component: () => import('../views/monitor/globalmonitor/globalmonitor.vue') },
            //{ path: 'globalmonitor1', permission: 'Pages.Globalmonitor', meta: { title: '设备分析' }, name: 'globalmonitor1', component: () => import('../views/monitor/globalmonitor/newfglobal.vue') },
            { path: 'smokecribdata', permission: 'Pages.SmokecribData', meta: { title: 'SmokecribData' }, name: 'smokecribdata', component: () => import('../views/monitor/smokecribdata/smokecribdata.vue') },
            { path: 'warehouseanalyse', permission: 'Pages.WareHouseAnalyses', meta: { title: 'WareHouseAnalyses' }, name: 'warehouseanalyse', component: () => import('../views/monitor/warehouseanalyse/warehouseanalyse.vue') },
            { path: 'lostdataanalyse', permission: 'Pages.LostDataAnalyse', meta: { title: 'LostDataAnalyse' }, name: 'lostdataanalyse', component: () => import('../views/monitor/lostdataanalyse/lostdataanalyse.vue') },
            //{ path: 'analysesmokecrib', permission: 'Pages.SmokecribData1', meta: { title: 'AnalyseSmokecrib' }, name: 'analysesmokecrib',hidden:true, component: () => import('../views/monitor/smokecribdata/analyse-smokecrib.vue')},
        ]
    },
    {
        path: '/realtimedatas',
        name: 'realtimedatas',
        permission: '',
        meta: { title: '实时数据' },
        icon: 'md-reorder',
        component: main,
        children: [
           { path: 'enthrealtimedata', permission: 'Pages.EnThrealTimeDatas', meta: { title: 'NewThE' }, name: 'Enthrealtimedata', component: () => import('../views/monitor/enthrealtimedata/enthrealtimedata.vue') },
            { path: 'threaltimedata', permission: 'Pages.ThrealTimeDatas', meta: { title: 'NewThC' }, name: 'threaltimedata', component: () => import('../views/monitor/threaltimedata/threaltimedata.vue') },
            { path: 'realtimedata', permission: 'Pages.Equipments', meta: { title: 'NewTrap' }, name: 'realtimedata', component: () => import('../views/monitor/realtimedata/realtimedata.vue') },
            //{ path: 'moirealtimedata', permission: 'Pages.MoirealTimeDatas', meta: { title: 'MoirealTimeDatas' }, name: 'Moirealtimedata', component: () => import('../views/monitor/moirealtimedata/moirealtimedata.vue') },
            { path: 'gasdata', permission: 'Pages.GasDatas', meta: { title: 'NewGas' }, name: 'GasData', component: () => import('../views/monitor/gasdata/gasdata.vue') },
            { path: 'inairdata', permission: 'Pages.InairDatas', meta: { title: 'NewInair' }, name: 'InairData', component: () => import('../views/monitor/inairdata/inairdata.vue') },
            { path: 'outairdata', permission: 'Pages.OutAirDatas', meta: { title: 'NewOutair' }, name: 'outairdata', component: () => import('../views/monitor/outairtimedata/outairtimedata.vue') },
            { path: 'miodata', permission: 'Pages.MoistureDatas', meta: { title: 'NewMoisture' }, name: 'miodata', component: () => import('../views/monitor/miodata/miodata.vue') },
            //{ path: 'analysesmokecrib', permission: 'Pages.SmokecribData1', meta: { title: 'AnalyseSmokecrib' }, name: 'analysesmokecrib',hidden:true, component: () => import('../views/monitor/smokecribdata/analyse-smokecrib.vue')},
        ]
    },
    {
        path: '/history',
        name: 'history',
        permission: '',
        meta: { title: '历史数据' },
        icon: 'ios-time',
        component: main,
        children: [
            { path: 'enthdatahistory', permission: 'Pages.EnThrealTimeDatas', meta: { title: 'NewThE' }, name: 'EnThdataHistory', component: () => import('../views/monitor/enthdatahistory/enthdatahistory.vue') },
            { path: 'thdatahistory', permission: 'Pages.ThrealTimeDatas', meta: { title: 'NewThC' }, name: 'ThdataHistory', component: () => import('../views/monitor/thdatahistory/thdatahistory.vue') },
            { path: 'trapdatahistory', permission: 'Pages.RealTimeDatas', meta: { title: 'NewTrap' }, name: 'TrapdataHistory', component: () => import('../views/monitor/trapdatahistory/trapdatahistory.vue') },
            { path: 'trapdataanalyse', permission: 'Pages.NewTrapAnalyse', meta: { title: 'NewTrapAnalyse' }, name: 'trapdataanalyse', component: () => import('../views/monitor/trapdataanalyse/trapdataAnalyse.vue') },
            { path: 'gashistoryedata', permission: 'Pages.GasDatas', meta: { title: 'NewGas' }, name: 'GasHistoryData', component: () => import('../views/monitor/gashistoryedata/gashistoryedata.vue') },
            { path: 'inairhistoryedata', permission: 'Pages.InairDatas', meta: { title: 'NewInair' }, name: 'InairHistoryData', component: () => import('../views/monitor/inairhistoryedata/inairhistoryedata.vue') },
            { path: 'outairdatahistory', permission: 'Pages.OutAirDatas', meta: { title: 'NewOutair' }, name: 'outairhistorydata', component: () => import('../views/monitor/outairdatahistory/outairdatahistory.vue') },
            { path: 'miohistoryedata', permission: 'Pages.MoistureDatas', meta: { title: 'NewMoisture' }, name: 'miohistoryedata', component: () => import('../views/monitor/miohistoryedata/miohistoryedata.vue') },
        ]
    }, {
        path: '/ware',
        name: 'ware',
        permission: '',
        meta: { title: '库区管理' },
        icon: 'logo-buffer',
        component: main,
        children: [
            { path: 'factory', permission: 'Pages.Factorys', meta: { title: 'Factorys' }, name: 'factory', component: () => import('../views/setting/factory/factory.vue') },
            { path: 'warehouse', permission: 'Pages.Warehouses', meta: { title: 'Warehouses' }, name: 'warehouse', component: () => import('../views/warehouse/warehouse/warehouse.vue') },
            { path: 'floor', permission: 'Pages.Floors', meta: { title: 'Floors' }, name: 'floor', component: () => import('../views/warehouse/floor/floor.vue') },
            { path: 'smokecrib', permission: 'Pages.Smokecribs', meta: { title: 'Smokecribs' }, name: 'smokecrib', component: () => import('../views/equipment/smokecrib/smokecrib.vue') },
            { path: 'Smokeleafs', permission: 'Pages.Smokeleafs', meta: { title: 'Smokeleafs' }, name: 'Smokeleafs', component: () => import('../views/equipment/smokeleaf/smokeleaf.vue') },
        ]
    }, {
        path: '/equip',
        name: 'equip',
        permission: '',
        meta: { title: '设备管理' },
        icon: 'ios-easel',
        component: main,
        children: [
            // icon: 'iconfont icon-hezi',
            { path: 'thequipment', permission: 'Pages.Thequipments', meta: { title: 'NewThEThC' }, name: 'thequipment', component: () => import('../views/equipment/thequipment/thequipment.vue') },
            { path: 'equipment', permission: 'Pages.Equipments', meta: { title: 'NewTrap' }, name: 'equipment', component: () => import('../views/equipment/equipment/equipment.vue') },
            { path: 'gasequipment', permission: 'Pages.GasEquipments', meta: { title: 'NewGas' }, name: 'gasequipment', component: () => import('../views/equipment/gasequipment/gasequipment.vue') },
            { path: 'inairequipment', permission: 'Pages.InairEquipments', meta: { title: 'NewInair' }, name: 'inairequipment', component: () => import('../views/equipment/inairequipment/inairequipment.vue') },
            { path: 'outairequipment', permission: 'Pages.OutAirEquipments', meta: { title: 'NewOutair' }, name: 'outairequipment', component: () => import('../views/equipment/outair_equipment/outair_equipment.vue') },
            { path: 'moiequipment', permission: 'Pages.MoistureEquipments', meta: { title: 'NewMoisture' }, name: 'moiequipment', component: () => import('../views/equipment/moiequipment/moiequipment.vue') },
            { path: 'gwequipment', permission: 'Pages.Gwequipments', meta: { title: 'Gwequipments' }, name: 'gwequipment', component: () => import('../views/equipment/gwequipment/gwequipment.vue') },
        ]
    }
    , {
        path: '/thresholds',
        name: 'thresholds',
        permission: '',
        meta: { title: '阈值管理' },
        icon: 'md-analytics',
        component: main,
        children: [
            { path: 'ththreshold', permission: 'Pages.Ththresholds', meta: { title: 'NewThEThC' }, name: 'ththreshold', component: () => import('../views/warning/ththreshold/ththreshold.vue') },
            { path: 'threshold', permission: 'Pages.Thresholds', meta: { title: 'NewTrap' }, name: 'threshold', component: () => import('../views/warning/threshold/threshold.vue') },
            { path: 'gasthreshold', permission: 'Pages.GasThresholds', meta: { title: 'NewGas' }, name: 'gasthreshold', component: () => import('../views/warning/gasthreshold/gasthreshold.vue') },
            { path: 'inairthreshold', permission: 'Pages.InairThresholds', meta: { title: 'NewInair' }, name: 'inairthreshold', component: () => import('../views/warning/inairthreshold/inairthreshold.vue') },
            { path: 'outairthreshold', permission: 'Pages.OutAirThresholds', meta: { title: 'NewOutair' }, name: 'outairthreshold', component: () => import('../views/warning/outairthreshold/outairthreshold.vue') },
            { path: 'miothreshold', permission: 'Pages.MoistureThresholds', meta: { title: 'NewMoisture' }, name: 'miothreshold', component: () => import('../views/warning/miothreshold/miothreshold.vue') },
        ]
    }, {
        path: '/warning',
        name: 'warning',
        permission: '',
        meta: { title: '预警管理' },
        icon: 'ios-alert',
        component: main,
        children: [
            { path: 'threcord', permission: 'Pages.Threcords', meta: { title: 'NewThEThC' }, name: 'threcord', component: () => import('../views/warning/threcord/threcord.vue') },
            { path: 'record', permission: 'Pages.Records', meta: { title: 'NewTrap' }, name: 'record', component: () => import('../views/warning/record/record.vue') },
            { path: 'gasrecord', permission: 'Pages.Gasrecords', meta: { title: 'NewGas' }, name: 'gasrecord', component: () => import('../views/warning/gasrecord/gasrecord.vue') },
            //{ path: 'gashandlewarning', permission: 'Pages.GasHandlewarnings', meta: { title: 'GasHandlewarnings' }, name: 'gashandlewarning', component: () => import('../views/warning/gashandlewarning/gashandlewarning.vue') },
            { path: 'inairrecord', permission: 'Pages.Inairrecords', meta: { title: 'NewInair' }, name: 'inairrecord', component: () => import('../views/warning/inairrecord/inairrecord.vue') },
            //{ path: 'inairhandlewarning', permission: 'Pages.InairHandlewarnings', meta: { title: 'InairHandlewarnings' }, name: 'inairhandlewarning', component: () => import('../views/warning/inairhandlewarning/inairhandlewarning.vue') },
            { path: 'outairhandlewarning', permission: 'Pages.OutAirHandlewarnings', meta: { title: 'NewOutair' }, name: 'outair_handlewarning', component: () => import('../views/warning/outairhandlewarning/outairhandlewarning.vue') },
            { path: 'miorecord', permission: 'Pages.MoistureHandleWarnings', meta: { title: 'NewMoisture' }, name: 'miorecord', component: () => import('../views/warning/miorecord/miorecord.vue') },
            //{ path: 'miohandlewarning', permission: 'Pages.MoistureHandleWarnings', meta: { title: 'MoistureHandleWarnings' }, name: 'miohandlewarning', component: () => import('../views/warning/miohandlewarning/miohandlewarning.vue') },
            { path: 'electricwarning', permission: 'Pages.Electricwarning', meta: { title: 'Electricwarning' }, name: 'electricwarning', component: () => import('../views/warning/electricwarning/electricwarning.vue') },
            { path: 'offlinewarning', permission: 'Pages.Offlinewarning', meta: { title: 'Offlinewarning' }, name: 'offlinewarning', component: () => import('../views/warning/offlinewarning/offlinewarning.vue') },
            { path: 'handlewarning', permission: 'Pages.Handlewarning', meta: { title: 'Handlewarning' }, name: 'handlewarning', component: () => import('../views/warning/handlewarning/handlewarning.vue') },
        ]
    }, {
        path: '/setting',
        name: 'setting',
        permission: '',
        meta: { title: '系统设置' },
        icon: 'md-settings',
        component: main,
        children: [

            { path: 'user', permission: 'Pages.Users', meta: { title: 'Users' }, name: 'user', component: () => import('../views/setting/user/user.vue') },
            { path: 'role', permission: 'Pages.Roles', meta: { title: 'Roles' }, name: 'role', component: () => import('../views/setting/role/role.vue') },
            { path: 'tenant', permission: 'Pages.Tenants', meta: { title: 'Tenants' }, name: 'tenant', component: () => import('../views/setting/tenant/tenant.vue') },
            { path: 'company', permission: 'Pages.Companys', meta: { title: 'Companys' }, name: 'company', component: () => import('../views/setting/company/company.vue') },
            { path: 'changepassword', permission: 'Pages.ChangePassWords', meta: { title: 'ChangePassword' }, name: 'changepassword', component: () => import('../views/setting/changepassword/changepassword.vue') },
            { path: 'editcompanyacname', permission: 'Pages.EditCompanyacNames', meta: { title: 'EditCompanyacNames' }, name: 'editcompanyacname', component: () => import('../views/setting/editcompanyacname/editcompanyacname.vue') },
        ]
    }, {
        path: '/logs',
        name: 'logs',
        permission: '',
        meta: { title: '日志管理' },
        icon: 'ios-paper',
        component: main,
        children: [
            { path: 'auditlog', permission: 'Pages.AuditLogs', meta: { title: 'AuditLogs' }, name: 'auditlog', component: () => import('../views/logs/auditlog/auditlog.vue') },
            { path: 'userloginattempt', permission: 'Pages.Userloginattempts', meta: { title: 'Userloginattempts' }, name: 'userloginattempt', component: () => import('../views/logs/userloginattempt/userloginattempt.vue') },
        ]
    }
]

export const routers = [
    loginRouter,
    ...threeyanyeRouter,
    ...threefuliaoRouter,
    locking,
    ...appRouters,
    otherRouters,
    screenRouter
];
